import { url } from '@tencent/ppd-base-libs';

/**
 * @description 一些辅助方法
 */
/**
 * 元转分
 * @param String num 输入金额
 */
const yuan2fen = num => Math.round(parseFloat(num) * 100)   // 避免浮点数的问题
  ;
/**
 * 分转元
 * @param String num
 */
const fen2yuan = num => (parseInt(num, 10) / 100).toFixed(2);

/**
 * 将金额进行格式化输出
 * @method toCurrency
 * @requires string
 * @param {String} val 需要进行格式化的数额
 * @param {Number} bit 进行格式化的位数
 * @return {String} 格式化后字符串
 * @example
 *   123212 -> 123,212.00
 */
const toCurrency = (srcVal, srcBit, srcPptions) => {
  let options = srcPptions;
  let val = srcVal;
  let bit = srcBit;
  options = options || { decimal: true };
  val = val || '';
  bit = bit || 2;

  const pattern = /^(-?)(\d+)(\.\d+)?$/;
  const macher = pattern.exec(val);
  const sign = null !== macher ? (RegExp.$1 || '') : '';
  const integer = null !== macher ? (RegExp.$2 || '0') : '0';
  let decimal = null !== macher ? (RegExp.$3 || '.00') : '.00';
  const size = integer.length;
  const mod = size > 3 ? size % 3 : 0;
  let tmp = '';
  const start = 0 === mod ? '' : `${integer.substr(0, mod)},`;
  let flag = 0;

  if (options.decimal) {
    decimal = '' === decimal ? '.00' : decimal;
    decimal = fillAfter(decimal, 0, bit + 1).substr(0, bit + 1);
  } else {
    decimal = '';
  }

  for (let i = mod; i < size; i++) {
    tmp += integer.charAt(i);
    flag += 1;
    if (flag % 3 === 0 && i < size - 1) {
      tmp += ',';
      flag = 0;
    }
  }

  return sign + start + tmp + decimal;
};
/**
 * 向后填充
 * @method fillAfter
 * @param {String} instr 输入的字符串
 * @param {String} chr 填充的字符
 * @param {Number} bit 位数
 * @return {String} 填充后的字符串
 */
const fillAfter = (instr, chr, bit) => {
  const len = instr.length;
  const shift = bit - len + 1;
  let str = instr;
  if (shift > 0) {
    const a = new Array(shift);
    str = str + a.join(chr);
  }
  return str;
};


const parseAmount = (srcVal, oldAmount) => {
  let val = srcVal;
  val = val || '';
  // 1、第1个输入0时，自动填充为"0."；
  // 2、去掉多个小数点，只保留一个小数点
  // 3、限制输入长度为8位；
  // 4、只允许输入2为小数；
  // 5、0开头，后面却不是小数点，那么删除这个0
  if ('' === oldAmount && ('0' === val || '.' === val)) {
    val = '0.';
  }

  if (val.indexOf('.') !== val.lastIndexOf('.')) {
    val = val.substr(0, val.length - 1);
  }

  val = val.substr(0, 8);
  val = val.replace(/^(\d+)(\.)(\d)\d*$/, '$1$2$3');
  val = val.replace(/^0(\d.*)$/, '$1');

  return val;
};

const fillVar = (rawStr, obj) => {
  const itemArr = Object.keys(obj);
  let str = rawStr;
  itemArr.forEach((element) => {
    const pattern = `\\$\\{${element}\\}`;
    const reg = new RegExp(pattern, 'g');
    str = str.replace(reg, obj[element]);
  });

  return str;
};
/**
 * 计算str的长度（字符长度）
 */
const myLen = (str) => {
  // 计算长度（字符长度）
  const han = str.replace(/[^\u4e00-\u9fa5]/g, '');
  const len = str.length + han.length;

  return len;
};

const doSubstr = (str, maxLen) => {
  // 截取字符串
  let nStr = str.substr(0, maxLen);   // 最长的情况
  const len = myLen(nStr);   // 计算字符数
  if (len > maxLen) {
    if (len === (maxLen + 1) && !/[\u4e00-\u9fa5]/.test(nStr.substr(nStr.length - 1, 1))) {    // 有可能是因为最后一个是中文
      // 如果刚好是21个字符，且最后一个不是中文，那么砍掉
      nStr = nStr.substr(0, nStr.length - 1);
    } else if (len > (maxLen + 1)) {
      // 再截取
      nStr = nStr.substr(0, nStr.length - ((len - maxLen) / 2));

      // @ts-ignore
      nStr = doSubstr(nStr);
    }
  }

  return nStr;
};

const mySubstr = (str, maxLen) => doSubstr(str, maxLen);

/**
 * 滚动频率限制
 */
const throttle = (f, gap, execAfterAction = false) => {
  let next = true;
  let afterAction;
  return (...arg) => {
    if (execAfterAction) {
      clearTimeout(afterAction);
      // 结束后再执行一次
      afterAction = setTimeout(() => {
        f(...arg);
      }, gap);
    }
    if (next) {
      next = false;
      f(...arg);
      setTimeout(() => {
        next = true;
      }, gap);
    }
  };
};

/**
 * 获取页面滚动距离
 */
const getScrollTop = () => {
  let scrollTop = window.pageYOffset || 0;

  if (document.scrollingElement) {
    ({ scrollTop } = document.scrollingElement);
  } else if (document.body.scrollTop) {
    ({ scrollTop } = document.body);
  }

  return scrollTop;
};

/**
 * 刷新dom
 */
const refleshDom = () => {
  if (document.scrollingElement) {
    // @ts-ignore
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
  } else {
    document.body.scrollTop = document.body.scrollTop;
  }
};
/**
 * 设置滚动
 */
const setScrollTop = (top) => {
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = top;
  } else {
    document.body.scrollTop = top;
  }
};

// 時間對比
const checkDate = (start, end) => {
  if (!start && !end) {
    return false;
  }
  const timeStamp = (new Date()).getTime();
  const getDateTime = function (str, completion) {
    let result = [];
    const strArr = str.split(' ');
    if (strArr.length === 1) {
      strArr.push(completion);
    }
    const reg = /.+\/.+\/.+/;
    let key = '-';
    if (reg.test(strArr)) {
      key = '/';
    }
    result = result.concat(strArr[0].split(key));
    result = result.concat(strArr[1].split(':'));
    return new Date(
      result[0], parseInt(result[1], 10) - 1,
      parseInt(result[2], 10), parseInt(result[3], 10),
      parseInt(result[4], 10), parseInt(result[5], 10),
    ).getTime();
  };
  const startTime = getDateTime(start, '00:00:00');
  const endTime = getDateTime(end, '23:59:59');

  if (startTime < timeStamp && endTime > timeStamp) {
    return true;
  }
  return false;
};

// 99公益日日期
const isTencentCharity = () => {
  const isTestTag = +url.getUrlParam('istest') === 1;
  if (checkDate('2023-09-01', '2023-09-10') || isTestTag) {
    return true;
  }
  return false;
};

// 99公益日项目
const isTencentCharityProject = (isNineProj: boolean) => {
  return isTencentCharity() && isNineProj;
};

// 日行一善的banner展示日期
const isShowActBanner = () => {
  if (checkDate('2022-05-08', '2022-12-31')) {
    return true;
  }
  return false;
};

// 返回随机数列表
const getRamdonNumberList = (arr: number[]) => {
  return arr.sort(() => {
    return Math.random() - 0.5;
  });
};

// 日行一善日日期
const isGoodDeedDay = () => {
  const isTestTag = +url.getUrlParam('outdeed') === 1;
  if (isTestTag) return false;
  if (checkDate('2024/01/01', '2024/02/05')) {
    return true;
  }
  return false;
};

export {
  yuan2fen,
  fen2yuan,
  toCurrency,
  parseAmount,
  fillVar,
  myLen,
  mySubstr,
  throttle,
  getScrollTop,
  setScrollTop,
  refleshDom,
  isTencentCharity,
  isTencentCharityProject,
  isShowActBanner,
  getRamdonNumberList,
  isGoodDeedDay,
};
